import { useEffect, useState } from 'react';
import InputService from '@/utils/input-service';

function TextInputValue({ identifier, placeholder = '' }) {
	const [value, setValue] = useState(placeholder);

	useEffect(() => {
		const inputService = InputService.getInstance();

		const onInputChanged = () => {
			setValue(inputService.getInputValue(identifier) || placeholder);
		};

		if (inputService.isRegistered(identifier)) {
			setValue(inputService.getInputValue(identifier) || placeholder);
			inputService.registerListener(identifier, onInputChanged);
		}

		return () => {
			inputService.unregisterListener(identifier, onInputChanged);
		};
	}, []);

	return value || '';
}

export default TextInputValue;
